import { MultiSelectFilterOption } from 'deckard-ui/dist/components/MultiSelectFilter/MultiSelectFilter';
import { VIOLATION_TYPE_TO_USER_STRING_MAP } from '../constants';
import { ViolationNode } from '../types';

const safeLabel = (rawType: string) => {
  return VIOLATION_TYPE_TO_USER_STRING_MAP[rawType] || rawType;
};

export const generateViolationTypesForDropdown = (
  data: ViolationNode[]
): MultiSelectFilterOption[] => {
  const uniqueTypes = [...new Set(data.map((violation) => violation.rawType))];

  return uniqueTypes
    .map((rawType) => ({
      value: safeLabel(rawType),
      key: rawType,
    }))
    .sort((a, b) => a.value.localeCompare(b.value));
};
